import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ToastController, ModalController } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';
import { PopupPage } from '../../../popup/popup';
import { ChooseprocessesPage } from '../chooseprocesses/chooseprocesses';
import * as moment from 'moment';

/**
 * Generated class for the Editagrculture1Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editagrculture1',
  templateUrl: 'editagrculture1.html',
})
export class Editagrculture1Page {
  cb: any
  id = -1
  name = ''
  selectedProcName = ''
  selectedProcIds = []
  selC = []
  procArray = []
  values: Array<string> = [];
  groups = []
  arrayChecked = []
  processids = ''
  _ppaths = []
  selectedPP = '--- Изберете артикл ---'

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController, public toastCtrl: ToastController, public modalCtrl: ModalController) {
    this.id = this.navParams.get('id')
    this.name = navParams.get('name')
    this.cb = navParams.get('cb')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad Editagrculture1Page');
    this.getProcesses()
    this.getPPaths()
  }

  checkGroups() {
    var hasPar = false;
    var hasCons = false;
    var parIdx = -1;
    for (var g = 0; g < this.groups.length; g++) {
      hasPar = false;
      hasCons = false;
      if (!this.groups[g].cons) parIdx = g;

      for (var g1 = g + 1; g1 < this.groups.length; g1++) {
        if (this.groups[g1].cons == false) {
          hasPar = true;
          break;
        }
      }

      for (var g1 = g + 1; g1 < this.groups.length; g1++) {
        if (this.groups[g1].cons == true) {
          hasCons = true;
          break;
        }
      }
      this.groups[g].haspar = hasPar;
      this.groups[g].hascons = hasCons;
      this.groups[g].paridx = parIdx;
      if (g == this.groups.length - 1) this.groups[g].nextcons = false;
      else {
        this.groups[g].nextcons = this.groups[g + 1].cons;
      }
    }
    //debugger
  }

  deleteItem(_gIdx, _aIdx) {
    //alert(_gIdx + ' ' + _aIdx)
    if (_aIdx == 0) {
      for (var p = 0; p < this.procArray.length; p++) {
        for (var p1 = 0; p1 < this.groups[_gIdx].arr.length; p1++) {
          if (this.procArray[p].id + '' == this.groups[_gIdx].arr[p1].id + '') {
            this.procArray[p].selected = false
          }
        }
      }
      this.groups.splice(_gIdx, 1)
    } else {
      for (var p = 0; p < this.procArray.length; p++) {
        if (this.procArray[p].id + '' == this.groups[_gIdx].arr[_aIdx].id + '') {
          this.procArray[p].selected = false
        }
      }
      this.groups[_gIdx].arr.splice(_aIdx, 1)
    }
    this.checkGroups();
  }

  reorderItems(from, to, _gIdx) {
    let element = this.groups[_gIdx].arr[from];
    this.groups[_gIdx].arr.splice(from, 1);
    this.groups[_gIdx].arr.splice(to, 0, element);
    this.checkGroups();
  }

  sec2str2(_sec) {
    if (_sec == undefined || _sec == null) _sec = -1;
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      return str;
    }
    else {
      return '-1';
    }
  }

  getProductionPath(_articleid) {
    var _dat = {
      articleid: this.gn.crypt(_articleid)
    }
    var _groupsTmp = []
    var lastParGroupNum = -2;
    var _cons = false;
    var _consTmp = false;
    var _flag = false;
    var _arrtmp = []
    var _that = this
    this.gn._Post('/api/gn/getproductionpath', _dat, function (_data) {
      if (_data.length > 0) {
        lastParGroupNum = _data[0].pargroupnum;
        for (var d = 0; d < _data.length; d++) {
          if (_data[d].pargroupnum != lastParGroupNum || _data[d].ptype == 'consequential') {
            _groupsTmp.push({ arr: _arrtmp, cons: _cons })
            _arrtmp = [];
          }

          _consTmp = _data[d].ptype == 'consequential' ? true : false;
          if (_consTmp) {
            _flag = false;
          } else {
            _flag = true;
          }
          for (var p = 0; p < _that.procArray.length; p++) {
            if (_that.procArray[p].id + '' == _data[d].pid + '') {
              _that.procArray[p].selected = true
            }
          }

          _arrtmp.push({ id: _data[d].pid, name: _data[d].processname, flag: _flag, cons: _consTmp, avgduration: _that.sec2str2(_data[d].avgduration) })

          lastParGroupNum = _data[d].pargroupnum
          _cons = _data[d].ptype == 'consequential' ? true : false;
        }
        _groupsTmp.push({ arr: _arrtmp, cons: _cons })
        _that.groups = _groupsTmp;
        _that.checkGroups();
        //_groupsTmp
      }
    })
  }
  doSave(_id, _name, _op) {
    // console.log(_id, _name, _op)
    //this.groups
    var _res = []
    var _rbr = 1;
    var _ptype = ''
    var _pargroupnum = -1;
    var _lastpargroupnum = -1;
    var _prevpargroupnum = -1;
    var _prevpid = -1;
    var _gIdx = 0;

    for (var g = 0; g < this.groups.length; g++) {
      if (!this.groups[g].cons)
        _gIdx++;
      for (var a = 0; a < this.groups[g].arr.length; a++) {
        if (this.groups[g].arr[a].cons) {
          _ptype = 'consequential'
          _prevpargroupnum = _gIdx;
          _pargroupnum = -1;
          _prevpid = -1;
        } else {
          _ptype = 'parallel'
          _pargroupnum = _gIdx;
          _prevpargroupnum = -1;
          if (_pargroupnum != _lastpargroupnum) {
            _prevpid = -1;
          }
        }
        _res.push({ rbr: _rbr, pid: this.groups[g].arr[a].id, ptype: _ptype, pargroupnum: _pargroupnum, prevpargroupnum: _prevpargroupnum, prevpid: _prevpid })
        _rbr++;
        //parallel
        if (!this.groups[g].arr[a].cons) {
          _prevpid = this.groups[g].arr[a].id;
        }
        _lastpargroupnum = _pargroupnum;
      }
    }
    var _that = this
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      id: this.gn.crypt(_id),
      name: this.gn.crypt(_name),
      op: this.gn.crypt(_op),
      resultArr: _res,
    }
    this.gn._Post('/api/gn/addarticles', _dat, function (_data) {
      _that.cb()
      _that.navCtrl.pop()
    })
  }

  getPPaths() {
    var _that = this;
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId)
    }
    this.gn._Post('/api/gn/getPPaths', _dat, function (_data) {
      _that._ppaths = _data
    })
  }

  getProcesses() {
    var _that = this;
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId)
    }
    this.gn._Post('/api/gn/getProcesses', _dat, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        _that.procArray.push({ name: _data[i].processname, id: _data[i].id, selected: false })
      }
      if (_that.id != -1) {
        _that.getProductionPath(_that.id);
      }
    })
  }

  AddProcessGroup(_ev) {
    var _that = this
    var _dat = {
      selected: '',
      arrayData: this.procArray,
      selProcId: this.selectedProcIds,
      cons: false,
      cb: function (_arr, _cons) {
        // _that.loadData()
        _that.groups.push({ arr: _arr, cons: _cons })
        for (var a = 0; a < _arr.length; a++) {
          for (var p = 0; p < _that.procArray.length; p++) {
            if (_that.procArray[p].id + '' == _arr[a].id + '') {
              _that.procArray[p].selected = true
            }
          }
        }
        _that.checkGroups();
      }
    }
    const modal = this.modalCtrl.create(ChooseprocessesPage, _dat
      , { cssClass: "modal-fullscreen3" });
    modal.present();
  }

  AddConsProcess(_ev, _idx) {
    var _that = this
    var _dat = {
      selected: '',
      arrayData: this.procArray,
      selProcId: this.selectedProcIds,
      cons: true,
      idxMaster: _idx,
      cb: function (_arr, _cons, _idxMaster) {
        // _that.loadData()
        _that.groups.push({ arr: _arr, cons: _cons })
        let element = _that.groups[_that.groups.length - 1];
        _that.groups.splice(_that.groups.length - 1, 1);

        var _to = -1;// = _idxMaster + 1;
        for (var g = _idxMaster + 1; g < _that.groups.length; g++) {
          if (!_that.groups[g].cons) {
            _to = g;
            break;
          }
        }
        if (_to == -1) {
          _to = _that.groups.length;
        }

        _that.groups.splice(_to, 0, element);

        for (var a = 0; a < _arr.length; a++) {
          for (var p = 0; p < _that.procArray.length; p++) {
            if (_that.procArray[p].id + '' == _arr[a].id + '') {
              _that.procArray[p].selected = true
            }
          }
        }
        _that.checkGroups();
      }
    }
    const modal = this.modalCtrl.create(ChooseprocessesPage, _dat
      , { cssClass: "modal-fullscreen3" });
    modal.present();
  }

  pickPPath(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'PPaths', selected: '', arrayData: this._ppaths, callback: function (_text, _ids) {
        _that.selectedPP = _text
        _that.getProductionPath(_ids)
      }
    });
    popover.present({ ev: _ev });
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/agrculture/editagrculture1/editagrculture1.ts